/**
 * analytics.js — مُغَلِّف خَفيف فَوق PostHog المُحَمَّل في `public/index.html`.
 *
 * لِماذا لا نَستَورِد `posthog-js` كَمُكَتَبَة npm؟
 *   لِأَنّ `index.html` يُحَمِّل posthog عَبر snippet رَسميّ مُسبَقاً مَع
 *   مِفتاح المَشروع وَإعدادات الخُصوصيّة (mask_all_text, disable_session_recording).
 *   اِستِيراد المُكَتَبَة مَرَّةً أُخرى عَبر npm يُؤَدّي إلى تَهيئة مُكَرَّرَة وَزيادَة
 *   حَجم الحُزمَة بِـ ~100KB. نَستَخدِم `window.posthog` مُباشَرَةً بَدَلاً.
 *
 * ميزَة الـsnippet: حَتّى قَبل اِكتِمال تَحميل posthog SDK، كائِن `window.posthog`
 *   مَوجود كَطابور (queue stub) يَحفَظ النِّداءات وَيُنَفِّذها فور وُصول SDK.
 *   لِذا `track()` و `identify()` آمِنَة لِلاِستِدعاء في أيّ لَحظَة.
 *
 * تَعطيل التَّحليلات (لِلتَّطوير المَحَلّيّ): اِحذِف snippet posthog مِن
 *   `public/index.html` — كُلّ الدَّوال هُنا تُصبِح no-op تِلقائيّاً.
 */

function getPH() {
  if (typeof window === "undefined") return null;
  return window.posthog || null;
}

/** track('event_name', { ...properties }) — يَتَجاهَل بِصَمت إذا posthog غَير مُتاح. */
export function track(eventName, properties = {}) {
  const ph = getPH();
  if (!ph || typeof ph.capture !== "function") return;
  try {
    ph.capture(eventName, properties);
  } catch (e) {
    console.warn("[LexIQ analytics] capture failed:", e);
  }
}

/** identify(userId, traits) — يَربِط الجَلسَة بِالمُستَخدِم بَعد تَسجيل الدُّخول. */
export function identify(userId, traits = {}) {
  if (!userId) return;
  const ph = getPH();
  if (!ph || typeof ph.identify !== "function") return;
  try {
    ph.identify(String(userId), traits);
  } catch (e) {
    console.warn("[LexIQ analytics] identify failed:", e);
  }
}

/** reset() — يُلغي رِبط الجَلسَة بَعد تَسجيل الخُروج. */
export function resetIdentity() {
  const ph = getPH();
  if (!ph || typeof ph.reset !== "function") return;
  try {
    ph.reset();
  } catch (e) {
    console.warn("[LexIQ analytics] reset failed:", e);
  }
}

/** هَل posthog مُتاح فِعليّاً في الصَّفحَة (لِلتَّشخيص فَقَط). */
export const analyticsEnabled = () => Boolean(getPH());
